import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';


export const useCreateLcrWorksheet = (crId, lcrId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);
  const queryClient = useQueryClient();

  return useMutation(
    () => axiosInstance.post(liveCleanroom(orgId)
      .createLcrWorksheet(crId, lcrId)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['lcrWorksheets', crId, lcrId]);
        dispatch(
          showAlert({
            message: 'LCR worksheet created successfully',
            type: 'success',
          }),
        );
      },
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error creating LCR worksheet',
            type: 'error',
          }),
        );
      },
    },
  );
};
